import React, { useEffect, useState, useRef } from 'react'
import Axios from "axios";
import { isLeadFormFieldHidden } from '../../../utils/leadFormFieldUtils';


// const handleChangeCounrtryRequired = (e, label, type) => {
//     const checked = e.target.checked
//     setIsCheckedCountry(checked)
//     const payload = {
//         language_code,
//         label,
//         name: 'Country',
//         options: { required: checked },
//         survey_id,
//         type : type
//     }
//     dispatch(updateStaticField(payload))
// }

// const handleChangeStateRequired = (e, label, type) => {
//     const checked = e.target.checked
//     ///alert(checked)
//     setIsCheckedState(checked)
//     const payload = {
//         language_code,
//         label,
//         name: 'State',
//         options: { required: checked },
//         survey_id,
//         type : type
//     }
//     dispatch(updateStaticField(payload))
// }


const parseObjToArray = (inputObject) => {
    let inputArray = []
    Object.keys(inputObject).forEach((key) => {
        let inputProps = inputObject[key]
        inputArray.push(inputProps)
    })
    return inputArray
}

const CustomInput = ({ fieldData, className, formikData }) => {
    const [countryLists, setCountryLists] = useState([]);
    const [states, setStates] = useState([]);
    const [selectedCountry, setSelectedCountry] = useState('');
    const [selectedState, setSelectedState] = useState('');
    //const [selectedFieldType, setSelectedFieldType] = useState('');
    //const [phoneCode, setPhoneCode] = useState('');
    const language = localStorage.getItem('customer_language') ?? '22'
    const fieldName = fieldData.su_label_and_options && JSON.parse(fieldData.su_label_and_options)[language]
    const fieldType = fieldData.su_form_variable_type
    const { values, handleChange, handleBlur, touched, errors, setFieldValue, setFieldTouched } = formikData
    const effectRan = useRef(false); // ref to track if the effect has run
    //const [textWidth, setTextWidth] = useState(0);
    const spanRef = useRef(null);

    const getCountryListData = function () {
        Axios.post(process.env.REACT_APP_API_URL + "/frnt/getCountry").then((response) => {
            //console.log(response.data.data);
            if (response.data.statusCode === 200) {
                const CountryiesArray = response.data.data.countries;
                setCountryLists(CountryiesArray)

            } else {
                alert("Try Again, Error");
            }
        });
    }
    const combinedHandleChange = (e) => {
        handleCountryChange(e);
        handleChange(e);

    };
    const handleCountryChange = (e) => {
        //console.log(fieldData.su_name)
        const { value } = e.target;
        const selectedOption = e.target.selectedOptions[0];
        const data = selectedOption.getAttribute('data-val');
        setSelectedCountry(data);
        setFieldValue(fieldData.su_name, value);
        setFieldTouched(fieldData.su_name, true);

        const selectedCountryData = countryLists.find(country => country.id === parseInt(data, 10));
        //console.log("selectedCountryData",selectedCountryData.phonecode)
        // if (selectedCountryData) {
        //     setPhoneCode(selectedCountryData.phonecode ? selectedCountryData.phonecode : "");
        // } else {
        //     console.warn('Country data not found for selected value:', e.target.value);
        //     setPhoneCode(''); // Set a default phone code or handle the missing data as needed
        // }

        const newPhoneCode = selectedCountryData && selectedCountryData.phonecode ? `+${selectedCountryData.phonecode}-` : "";

        // Initialize busPhone1 if it doesn't exist
        if (!values?.busPhone1) {
            setFieldValue('busPhone1', newPhoneCode);
        }
    };
    useEffect(() => {
        if (spanRef.current && values?.busPhone1) {
            const spanWidth = spanRef.current.offsetWidth;
            setFieldValue("textWidth", spanWidth); // Store the width in formik state
        }
    }, [values?.busPhone1, setFieldValue]);
    const handleStateChange = (e) => {
        const { value } = e.target;
        const { name } = e.target;
        setSelectedState(value);
        setFieldValue('state', value);
        setFieldTouched('state', true);
        handleChange(e)
    }
    useEffect(() => {
        if (fieldName === 'Country' && !effectRan.current) {
            getCountryListData();
            effectRan.current = true; // Set the ref to true to indicate the effect has run
        }
    }, [fieldName]);
    useEffect(() => {
        //console.log('Selected Country:', selectedCountry);

        if (selectedCountry) {
            // Make API request to fetch states based on selectedCountry ID
            Axios.post(process.env.REACT_APP_API_URL + "/frnt/getCountryState", { "id": selectedCountry })
                .then((response) => {

                    if (response.data.statusCode === 200) {

                        const statesData = response.data.data.state;

                        setStates(statesData);  // Update states

                    } else {
                        setStates('')
                        console.error('Error fetching states:', response.data.message);
                    }

                })
                .catch(error => {
                    console.error('Error fetching states:', error);
                });
        } else {
            setStates([]);
        }

    }, [selectedCountry]); // Trigger effect when selectedCountry changes
    //Classes
    const divClasses = {
        text: 'form-floating',
        email: 'form-floating',
        number: 'form-floating',
        checkbox: 'form-check',
        radio: 'form-check'
    }

    const inputClasses = {
        text: 'form-control',
        email: 'form-control',
        number: 'form-control',
        checkbox: 'form-check-input',
        radio: 'form-check-input',
    }

    const labelClasses = {
        checkbox: 'form-check-label',
        radio: 'form-check-label',
    }

    if (isLeadFormFieldHidden(fieldData)) {
        return null;
    }

    if (fieldType === 1) {
        const inputs = fieldData.su_options && parseObjToArray(JSON.parse(fieldData.su_options))
        if (!inputs)
            return ''
        const isPhoneNumberField = fieldData.su_name === 'busPhone';
        return (
            <>
                {
                    inputs[0]?.type !== 'hidden' &&
                    <div className="col-md-6">
                        <div className={`${divClasses[inputs[0].type]} ${className}`} key={fieldName}>
                            {(inputs[0]?.type === 'checkbox' || inputs[0].type === 'radio') ?
                                // <div className='form-check-wrapper'>
                                //     {(inputs[0]?.type === 'checkbox' || inputs[0].type === 'radio') && <label htmlFor={fieldData.su_name}>{`${fieldName}${inputs[0].required ? '*' : ''}`}</label>}

                                //     {
                                //         inputs?.map((attributes, i) => {
                                //             let tmpattributes = { ...attributes }
                                //             delete tmpattributes.required
                                //             return (
                                //                 <React.Fragment key={i}>
                                //                     <input
                                //                         className={inputClasses[attributes.type]}
                                //                         id={`${fieldData.su_lead_gen_variable_id}_${i}`}
                                //                         name={fieldData.su_name}
                                //                         onChange={handleChange}
                                //                         onBlur={handleBlur}
                                //                         {...{ ...tmpattributes, value: attributes.type === 'checkbox' || attributes.type === 'radio' ? tmpattributes.value : (values ? (values[fieldData.su_name] ?? "") : "") }}
                                //                     />
                                //                     {attributes.value && <label className={labelClasses[attributes.type]} htmlFor={`${fieldData.su_lead_gen_variable_id}_${i}`}>{attributes.value}</label>}
                                //                 </React.Fragment>
                                //             )
                                //         })
                                //     }
                                //     {!(inputs[0]?.type === 'checkbox' || inputs[0].type === 'radio') && <label htmlFor={fieldData.su_name}>{`${fieldName}${inputs[0].required ? '*' : ''}`}</label>}
                                //     {touched[fieldData.su_name] && errors[fieldData.su_name] && <div className="error"> {errors[fieldData.su_name]}</div>}

                                // </div> 
                                <></>
                                :

                                // <>
                                //     {(inputs[0]?.type === 'checkbox' || inputs[0].type === 'radio') && <label htmlFor={fieldData.su_name}>{`${fieldName}${inputs[0].required ? '*' : ''}`}</label>}

                                //     {
                                //         inputs?.map((attributes, i) => {
                                //             let tmpattributes = { ...attributes }
                                //             delete tmpattributes.required
                                //             return (
                                //                 <React.Fragment key={i}>
                                //                     <input
                                //                         className={inputClasses[attributes.type]}
                                //                         id={`${fieldData.su_lead_gen_variable_id}_${i}`}
                                //                         name={fieldData.su_name}
                                //                         onChange={handleChange}
                                //                         onBlur={handleBlur}
                                //                         {...{ ...tmpattributes, value: attributes.type === 'checkbox' || attributes.type === 'radio' ? tmpattributes.value : (values ? (values[fieldData.su_name] ?? "") : "") }}
                                //                     />
                                //                     {attributes.value && <label className={labelClasses[attributes.type]} htmlFor={`${fieldData.su_lead_gen_variable_id}_${i}`}>{attributes.value}</label>}
                                //                 </React.Fragment>
                                //             )
                                //         })
                                //     }
                                //     {!(inputs[0]?.type === 'checkbox' || inputs[0].type === 'radio') && <label htmlFor={fieldData.su_name}>{`${fieldName}${inputs[0].required ? '*' : ''}`}</label>}
                                //     {touched[fieldData.su_name] && errors[fieldData.su_name] && <div className="error"> {errors[fieldData.su_name]}</div>}

                                // </>
                                <>

                                    {isPhoneNumberField ?

                                        <div className="form-floating mb-4">
                                            {inputs[0]?.phoneCountryCode && (
                                                <span className='text-label-code' ref={spanRef}>
                                                    {values?.busPhone1 || ""}
                                                </span>
                                            )}
                                            <input
                                                className={inputClasses[inputs[0].type]}
                                                id={fieldData.su_lead_gen_variable_id}
                                                name={fieldData.su_name}
                                                type="number"
                                                value={values ? (values[fieldData.su_name] ?? "") : ""}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                style={{ paddingLeft: `${values?.textWidth ? values.textWidth : 0}px` }}
                                            />
                                            <label htmlFor={fieldData.su_name}>{`${fieldName}${inputs[0].required ? '*' : ''}`}</label>
                                            {touched[fieldData.su_name] && errors[fieldData.su_name] && <div className="error"> {errors[fieldData.su_name]}</div>}
                                        </div>
                                        :
                                        <>
                                            {
                                                inputs?.map((attributes, i) => {
                                                    let tmpattributes = { ...attributes };
                                                    delete tmpattributes.required;
                                                    return (
                                                        <React.Fragment key={i}>
                                                            <input
                                                                className={inputClasses[attributes.type]}
                                                                id={`${fieldData.su_lead_gen_variable_id}_${i}`}
                                                                name={fieldData.su_name}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                                {...{ ...tmpattributes, value: (attributes.type === 'checkbox' || attributes.type === 'radio') ? tmpattributes.value : (values ? (values[fieldData.su_name] ?? "") : "") }}
                                                            />
                                                            {attributes.value && <label className={labelClasses[attributes.type]} htmlFor={`${fieldData.su_lead_gen_variable_id}_${i}`}>{attributes.value}</label>}
                                                        </React.Fragment>
                                                    );
                                                })
                                            }
                                            {!(inputs[0]?.type === 'checkbox' || inputs[0]?.type === 'radio') && <label htmlFor={fieldData.su_name}>{`${fieldName}${inputs[0].required ? '*' : ''}`}</label>}
                                            {touched[fieldData.su_name] && errors[fieldData.su_name] && <div className="error"> {errors[fieldData.su_name]}</div>}
                                        </>
                                    }
                                </>
                            }
                        </div>
                    </div>
                }
            </>
        )
    } else if (fieldType === 3) {
        let attributes = JSON.parse(fieldData.su_options)
        let options = attributes.option
        return (
            <>
                <div className="col-md-6">
                    <div className={className + ` form-floating`} >
                        <select
                            className='form-control'
                            name={fieldData.su_name}
                            id={fieldData.su_name}
                            onChange={handleChange}
                            value={values ? values[attributes.su_name] : ''}
                        // required={attributes.required === "required"}
                        >
                            <option value='' key=''>&nbsp;&nbsp;--Select--</option>

                            {
                                Object.keys(options).map((key) => (
                                    <option value={key} key={key}>&nbsp;&nbsp;{options[key]}</option>
                                ))
                            }
                        </select>
                        <label htmlFor={attributes.su_name}>{`${fieldName}${attributes.required ? '*' : ''}`}</label>
                        {touched[fieldData.su_name] && errors[fieldData.su_name] && <div className="error"> {errors[fieldData.su_name]}</div>}
                    </div>
                </div>
            </>
        )
    } else if (fieldType === 4) {
        let attributes = JSON.parse(fieldData.su_options)

        return (
            <>
                <div className="col-md-6">
                    <div className={className + ` form-floating`} >
                        <textarea
                            className='form-control'
                            name={fieldData.su_name}
                            id={fieldData.su_name}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values ? values[attributes.su_name] : ''}
                        >
                        </textarea>
                        <label htmlFor={attributes.su_name}>{`${fieldName}${attributes.required ? '*' : ''}`}</label>
                        {touched[fieldData.su_name] && errors[fieldData.su_name] && <div className="error"> {errors[fieldData.su_name]}</div>}
                    </div>
                </div>
            </>
        )
    } else if (fieldType === 12 || fieldType === 13) {
        let attributes;
        try {
            attributes = JSON.parse(fieldData.su_options || '{}');
        } catch (e) {
            attributes = {};
        }
        const type = attributes?.type || '';
        
        return (
            <>
                {fieldType === 12 && type === 'country' && (
                    <div className="col-md-6">
                        <div className={className + ` form-floating`}>
                            <select
                                className='form-control'
                                name={fieldData.su_name}
                                id={fieldData.su_name}
                                onChange={combinedHandleChange}
                                onBlur={handleBlur}
                                value={values?.[fieldData.su_name] || ''}
                            >
                                <option value='' key=''>&nbsp;&nbsp;--Select--</option>
                                {Array.isArray(countryLists) && countryLists.filter(country => country?.name).map(country => (
                                    <option value={country.name} data-val={country.id} key={country.id}>&nbsp;&nbsp;{country.name}</option>
                                ))}
                            </select>
                            <label htmlFor={fieldData.su_name}>{`${fieldName}${attributes?.required ? '*' : ''}`}</label>
                            {touched?.[fieldData.su_name] && errors?.[fieldData.su_name] && <div className="error"> {errors[fieldData.su_name]}</div>}
                        </div>
                    </div>
                )}

                {(!selectedCountry && type !== 'state') && (
                    <div className="col-md-6">
                        <div className={className + ` form-floating`}>
                            <select
                                className='form-control'
                                name="state"
                                id="state"
                                onChange={handleStateChange}
                                value={selectedState || ''}
                            >
                                <option value='' key=''>&nbsp;&nbsp;--Select--</option>
                                {Array.isArray(states) && states.map(state => state && (
                                    <option value={state.name} key={state.id}>&nbsp;&nbsp;{state.name}</option>
                                ))}
                            </select>
                            <label htmlFor="state">{`State${attributes?.required ? '*' : ''}`}</label>
                            {touched?.state && errors?.state && <div className="error"> {errors.state}</div>}
                        </div>
                    </div>
                )}

                {selectedCountry && (
                    <div className="col-md-6">
                        <div className={className + ` form-floating`}>
                            <select
                                className='form-control'
                                name="state"
                                id="state"
                                onChange={handleStateChange}
                                value={selectedState || ''}
                            >
                                <option value='' key=''>&nbsp;&nbsp;--Select--</option>
                                {Array.isArray(states) && states.map(state => state && (
                                    <option value={state.name} key={state.id}>&nbsp;&nbsp;{state.name}</option>
                                ))}
                            </select>
                            <label htmlFor="state">{`State${attributes?.required ? '*' : ''}`}</label>
                            {touched?.state && errors?.state && <div className="error"> {errors.state}</div>}
                        </div>
                    </div>
                )}
            </>
        )
    } else {
        return <></>
    }
}

export default CustomInput